import { Component, OnInit } from "@angular/core";
import { DashboardLayoutSettingService } from "../../../../core/services/dashboard-layout-setting.service";
import { DashboardReports } from "../../../../core/models/dashboard/dashboardReport";
import { DashboardSetting } from "../../../../core/models/dashboard/dashboardSetting";
import { UserSetting } from "../../../../core/models/dashboard/userSetting";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { DashboardService } from "../../../../core/services/dashboard.service";
import { DashboardReport } from "../../../../shared/enums/dashboardReports";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { LoaderService } from "../../../../core/services/loader.service";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-dashboard-layout-setting",
  templateUrl: "./dashboard-layout-setting.component.html",
  styleUrls: ["./dashboard-layout-setting.component.scss"],
  imports: [
    FormsModule,
    CommonModule,
    SelectModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class DashboardLayoutSettingComponent implements OnInit {
  quadreport1 = "";
  quadreport2 = "";
  quadreport3 = "";
  quadreport4 = "";

  dashboradReports1: DashboardReports[] = [];
  dashboradReports2: DashboardReports[] = [];
  dashboradReports3: DashboardReports[] = [];
  dashboradReports4: DashboardReports[] = [];
  userId = 0;

  constructor(
    private _dashboardLayoutSettingService: DashboardLayoutSettingService,
    private _dashboardService: DashboardService,
    private _loaderService: LoaderService,
    private _userManagementService: UserManagementService,
    private _profileFormService: ProfileFormService
  ) {
    this.dashboradReports1 =
      this._dashboardLayoutSettingService.dashboradReports1;
    this.dashboradReports2 =
      this._dashboardLayoutSettingService.dashboradReports2;
    this.dashboradReports3 =
      this._dashboardLayoutSettingService.dashboradReports3;
    this.dashboradReports4 =
      this._dashboardLayoutSettingService.dashboradReports4;
  }

  ngOnInit(): void {
    this.getUserProfile();
    this.getUserSetting();
  }

  getUserProfile() {
    this._userManagementService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userId = res.data.userId;
        this.getUserById(res.data.userId);
      });
  }

  onReportSelection1(val: SelectChangeEvent) {
    this.disabledFieldForQR2DropDown1(val.value);
    this.disabledFieldForQR3DropDown1(val.value);
    this.disabledFieldForQR4DropDown1(val.value);
    //this.disabledUnusedReport1();
  }

  onReportSelection2(val: SelectChangeEvent) {
    this.disabledFieldForQR1DropDown2(val.value);
    this.disabledFieldForQR3DropDown2(val.value);
    this.disabledFieldForQR4DropDown2(val.value);
  }

  onReportSelection3(val: SelectChangeEvent) {
    this.disabledFieldForQR1DropDown3(val.value);
    this.disabledFieldForQR2DropDown3(val.value);
    this.disabledFieldForQR4DropDown3(val.value);
  }

  onReportSelection4(val: SelectChangeEvent) {
    this.disabledFieldForQR1DropDown4(val.value);
    this.disabledFieldForQR2DropDown4(val.value);
    this.disabledFieldForQR3DropDown4(val.value);
  }

  disabledFieldForQR2DropDown1(name: string) {
    this.dashboradReports2.forEach(x => {
      if (x.name === name) {
        x.status = true;
      } else if (x.name === this.quadreport3) {
        x.status = true;
      } else if (x.name === this.quadreport4) {
        x.status = true;
      } else {
        x.status = false;
      }
    });
    this.disabledUnusedReport2();
  }
  disabledFieldForQR3DropDown1(name: string) {
    this.dashboradReports3.forEach(x => {
      if (x.name === name) {
        x.status = true;
      } else if (x.name === this.quadreport2) {
        x.status = true;
      } else if (x.name === this.quadreport4) {
        x.status = true;
      } else {
        x.status = false;
      }
    });
    this.disabledUnusedReport3();
  }
  disabledFieldForQR4DropDown1(name: string) {
    this.dashboradReports4.forEach(x => {
      if (x.name === name) {
        x.status = true;
      } else if (x.name === this.quadreport2) {
        x.status = true;
      } else if (x.name === this.quadreport3) {
        x.status = true;
      } else {
        x.status = false;
      }
    });
    this.disabledUnusedReport4();
  }

  disabledFieldForQR1DropDown2(name: string) {
    this.dashboradReports1.forEach(x => {
      if (x.name === name) {
        x.status = true;
      } else if (x.name === this.quadreport3) {
        x.status = true;
      } else if (x.name === this.quadreport4) {
        x.status = true;
      } else {
        x.status = false;
      }
    });
    this.disabledUnusedReport1();
  }
  disabledFieldForQR3DropDown2(name: string) {
    this.dashboradReports3.forEach(x => {
      if (x.name === name) {
        x.status = true;
      } else if (x.name === this.quadreport1) {
        x.status = true;
      } else if (x.name === this.quadreport4) {
        x.status = true;
      } else {
        x.status = false;
      }
    });
    this.disabledUnusedReport3();
  }
  disabledFieldForQR4DropDown2(name: string) {
    this.dashboradReports4.forEach(x => {
      if (x.name === name) {
        x.status = true;
      } else if (x.name === this.quadreport1) {
        x.status = true;
      } else if (x.name === this.quadreport3) {
        x.status = true;
      } else {
        x.status = false;
      }
    });
    this.disabledUnusedReport4();
  }

  disabledFieldForQR1DropDown3(name: string) {
    this.dashboradReports1.forEach(x => {
      if (x.name === name) {
        x.status = true;
      } else if (x.name === this.quadreport2) {
        x.status = true;
      } else if (x.name === this.quadreport4) {
        x.status = true;
      } else {
        x.status = false;
      }
    });
    this.disabledUnusedReport1();
  }
  disabledFieldForQR2DropDown3(name: string) {
    this.dashboradReports2.forEach(x => {
      if (x.name === name) {
        x.status = true;
      } else if (x.name === this.quadreport1) {
        x.status = true;
      } else if (x.name === this.quadreport4) {
        x.status = true;
      } else {
        x.status = false;
      }
    });
    this.disabledUnusedReport2();
  }
  disabledFieldForQR4DropDown3(name: string) {
    this.dashboradReports4.forEach(x => {
      if (x.name === name) {
        x.status = true;
      } else if (x.name === this.quadreport1) {
        x.status = true;
      } else if (x.name === this.quadreport2) {
        x.status = true;
      } else {
        x.status = false;
      }
    });
    this.disabledUnusedReport4();
  }

  disabledFieldForQR1DropDown4(name: string) {
    this.dashboradReports1.forEach(x => {
      if (x.name === name) {
        x.status = true;
      } else if (x.name === this.quadreport2) {
        x.status = true;
      } else if (x.name === this.quadreport3) {
        x.status = true;
      } else {
        x.status = false;
      }
    });
    this.disabledUnusedReport1();
  }
  disabledFieldForQR2DropDown4(name: string) {
    this.dashboradReports2.forEach(x => {
      if (x.name === name) {
        x.status = true;
      } else if (x.name === this.quadreport1) {
        x.status = true;
      } else if (x.name === this.quadreport3) {
        x.status = true;
      } else {
        x.status = false;
      }
    });
    this.disabledUnusedReport2();
  }
  disabledFieldForQR3DropDown4(name: string) {
    this.dashboradReports3.forEach(x => {
      if (x.name === name) {
        x.status = true;
      } else if (x.name === this.quadreport1) {
        x.status = true;
      } else if (x.name === this.quadreport2) {
        x.status = true;
      } else {
        x.status = false;
      }
    });
    this.disabledUnusedReport3();
  }

  addSaleOrderHeaderData() {
    this._loaderService.setLoaderState(true);

    const dashboardSetting: DashboardSetting = {
      qr1: this.quadreport1 || "",
      qr2: this.quadreport2 || "",
      qr3: this.quadreport3 || "",
      qr4: this.quadreport4 || "",
    };

    const dashboardSettingObject: UserSetting = {
      id: 0,
      userId: this.userId,
      dashboardReports: JSON.stringify(dashboardSetting),
      createdBy: "",
      createdDate: "",
      lastModifiedBy: "",
      lastModifiedDate: "",
      isActive: false,
    };

    this._dashboardService
      .addSaleOrderHeaderData(dashboardSettingObject)
      .subscribe({
        next: () => {
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getUserSetting() {
    this._loaderService.setLoaderState(true);
    this._dashboardService.GetUserSettings().subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data && res.status.toLowerCase() === "success") {
          const dashboardSetting = JSON.parse(res.data.dashboardReports);
          if (dashboardSetting.qr1) {
            this.quadreport1 = dashboardSetting.qr1;
            this.onReportSelection1(dashboardSetting.qr1);
          }
          if (dashboardSetting.qr2) {
            this.quadreport2 = dashboardSetting.qr2;
            this.onReportSelection2(dashboardSetting.qr2);
          }
          if (dashboardSetting.qr3) {
            this.quadreport3 = dashboardSetting.qr3;
            this.onReportSelection3(dashboardSetting.qr3);
          }
          if (dashboardSetting.qr4) {
            this.quadreport4 = dashboardSetting.qr4;
            this.onReportSelection4(dashboardSetting.qr4);
          }
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  disabledUnusedReport1() {
    this.dashboradReports1.forEach(x => {
      if (x.name === DashboardReport.CustomerYearOverYear) {
        x.status = true;
      } else if (x.name === DashboardReport.TopClients) {
        x.status = true;
      } else if (x.name === DashboardReport.MyOpenPOs) {
        x.status = true;
      } else if (x.name === DashboardReport.ReadyToBill) {
        x.status = true;
      } else if (x.name === DashboardReport.OrderDetail) {
        x.status = true;
      } else if (x.name === DashboardReport.CustomerwithDepositsandPrebills) {
        x.status = true;
      } else if (x.name === DashboardReport.TasksbyDueDate) {
        x.status = true;
      }
    });
  }

  disabledUnusedReport2() {
    this.dashboradReports2.forEach(x => {
      if (x.name === DashboardReport.CustomerYearOverYear) {
        x.status = true;
      } else if (x.name === DashboardReport.TopClients) {
        x.status = true;
      } else if (x.name === DashboardReport.MyOpenPOs) {
        x.status = true;
      } else if (x.name === DashboardReport.ReadyToBill) {
        x.status = true;
      } else if (x.name === DashboardReport.OrderDetail) {
        x.status = true;
      } else if (x.name === DashboardReport.CustomerwithDepositsandPrebills) {
        x.status = true;
      } else if (x.name === DashboardReport.TasksbyDueDate) {
        x.status = true;
      }
    });
  }

  disabledUnusedReport3() {
    this.dashboradReports3.forEach(x => {
      if (x.name === DashboardReport.CustomerYearOverYear) {
        x.status = true;
      } else if (x.name === DashboardReport.TopClients) {
        x.status = true;
      } else if (x.name === DashboardReport.MyOpenPOs) {
        x.status = true;
      } else if (x.name === DashboardReport.ReadyToBill) {
        x.status = true;
      } else if (x.name === DashboardReport.OrderDetail) {
        x.status = true;
      } else if (x.name === DashboardReport.CustomerwithDepositsandPrebills) {
        x.status = true;
      } else if (x.name === DashboardReport.TasksbyDueDate) {
        x.status = true;
      }
    });
  }

  disabledUnusedReport4() {
    this.dashboradReports4.forEach(x => {
      if (x.name === DashboardReport.CustomerYearOverYear) {
        x.status = true;
      } else if (x.name === DashboardReport.TopClients) {
        x.status = true;
      } else if (x.name === DashboardReport.MyOpenPOs) {
        x.status = true;
      } else if (x.name === DashboardReport.ReadyToBill) {
        x.status = true;
      } else if (x.name === DashboardReport.OrderDetail) {
        x.status = true;
      } else if (x.name === DashboardReport.CustomerwithDepositsandPrebills) {
        x.status = true;
      } else if (x.name === DashboardReport.TasksbyDueDate) {
        x.status = true;
      }
    });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res.data != null) {
          if (
            res?.data?.isLedgerActive === true ||
            res?.data?.userRoleId === UserRole.Admin
          ) {
            this.setYearOverYearDashboardReportInList();
          }
        }
      },
    });
  }

  setYearOverYearDashboardReportInList() {
    const obj = {
      id: 14,
      name: DashboardReport.YearOverYearDashboardReport,
      status: false,
    };

    if (this.dashboradReports1.findIndex(x => x.id === 14) === -1) {
      this.dashboradReports1.push(obj);
    }
    if (this.dashboradReports2.findIndex(x => x.id === 14) === -1) {
      this.dashboradReports2.push(obj);
    }
    if (this.dashboradReports3.findIndex(x => x.id === 14) === -1) {
      this.dashboradReports3.push(obj);
    }
    if (this.dashboradReports4.findIndex(x => x.id === 14) === -1) {
      this.dashboradReports4.push(obj);
    }
  }
}
